import React, {FC, useEffect} from 'react';
import {useAction} from "../../../../store/hooks/useAction";
import {useTypedSelector} from "../../../../store/hooks/useTypedSelector";
import JackpotLobbyComponent from "../Components/JackpotLobbyComponent";
interface QBLProps {
    atagParams: string | null,
    mode: string | null,
    ticketOpenMode: string | null,
    sourceParams: string | null,
}
const QuickbetLobby: FC <QBLProps> = ({atagParams, mode,ticketOpenMode, sourceParams}) => {
    const {getJackpotsData} = useAction();
    const {jackpotsData} = useTypedSelector((state) => state.jackpotsReducer);
    useEffect(()=>{
        getJackpotsData();
    }, [])
    return (
        <>
            {
                jackpotsData.length > 0 ?
                    <JackpotLobbyComponent data={jackpotsData} ticketOpenMode={ticketOpenMode} sourceParams={sourceParams} atagParams={atagParams} mode={mode}  />
                    : null
            }
        </>
    );

}

export default QuickbetLobby;
